import { isProd } from "../../config/isProd";

/**
 * @fileoverview Defines constants and configuration settings for analytics and event tracking.
 * @module CONSTANTS
 */

/**
 * Enumeration of event names used in tracking.
 * @enum {string}
 */
export const EVENTS = {
  ViewContent: "View-Content",
  PageView: "PageView",
  FindLocation: "FindLocation",
  Subscribe: "Subscribe",
  Contact: "Contact",
};

/**
 * Server-side API endpoints for tracking events.
 * @const {Object}
 */
export const API_ENDPOINTS = {
  Meta: false,
  Pinterest: false,
  GeoLookup: "/wp-json/wayne-sanderson-farms/v2/geo-lookup"
};

// Dev Tracking IDs
const DEV_IDS = {
  Facebook_Pixel: false,
  Pinterest_Pixel: false,
  Tiktok_Pixel: false,
  GA_Measurement: "G-W0BD1FZVJ8",
  // Additional pixel IDs can be added here as needed
};

// Live Tracking IDs
const PROD_IDS = {
  Facebook_Pixel: false,
  Pinterest_Pixel: false,
  Tiktok_Pixel: false,
  GA_Measurement: "G-GMQQ5CMZBE",
  // Additional pixel IDs can be added here as needed
};

// Export a function that returns the ID for a given platform based on if the domain contains waynesandersonfarms.com
export const getTrackingId = (platform) => {
  // If function isProd exists, use it to return prod IDs
  if ( typeof isProd === 'function' ) {
    const ids = isProd() ? PROD_IDS : DEV_IDS;
    return ids[platform] || null; // Return null if the platform ID is not found
  }
  return null;
};


/**
 * Button CSS classes for the privacy banner.
 * @const {Array}
 */
export const BUTTON_CLASSES = [
  "btn",
  "btn-primary",
  "min-w-[120px]",
  "m-1",
  "p-1",
  "w-auto"
];
